import type { GarmentGroup } from '@rosita/shared';

export const inputClass =
  'rounded-md border border-admin-border bg-white px-3 py-2 text-sm focus:border-admin-primary focus:outline-none';
export const primaryBtn =
  'rounded-md bg-admin-primary px-4 py-2 text-sm font-medium text-white hover:bg-admin-primary-hover disabled:opacity-50';
export const secondaryBtn =
  'rounded-md border border-admin-border bg-white px-3 py-2 text-sm hover:bg-admin-surface-alt';
export const dangerBtnText = 'text-sm text-admin-danger hover:underline';

/** PT labels for measurement-point garment groups (see GARMENT_GROUPS in shared). */
export const GARMENT_GROUP_LABELS: Record<GarmentGroup, string> = {
  tops: 'Partes de cima',
  bottoms: 'Partes de baixo',
  dresses: 'Vestidos e macacões',
  outerwear: 'Casacos e sobretudos',
  accessories: 'Acessórios',
};

export function slugify(input: string): string {
  return input
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
